export class ValidationHelper {
    static async validateNumericRange(value, min, max, $translate, translationKeys) {
        if (value === '') {
            return await $translate(translationKeys.empty);
        }
        const numValue = Number(value);
        if (isNaN(numValue)) {
            return await $translate(translationKeys.notNumber);
        }
        if (numValue % 1 !== 0) {
            return await $translate(translationKeys.decimal);
        }
        if (numValue > max || numValue < min) {
            return await $translate(translationKeys.outOfRange);
        }
        return '';
    }
}
